<template>
    <div class="home-page">
		<Header></Header>
		<div class="content-detail">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{detail.title}}</span>
			</div>
			<div class="content-detail" v-if="detail!=''">
				<p class="title fs50 ac text-overflow2">{{detail.info}}</p>
				<div class="mt30">
					<img class="content-img" :src="detail.image" width="100%" />
					<div class="detail-p mt30" :class="{'more':isMore}" v-html="detail.content">
					</div>
				</div>
			</div>
			<div class="mt50 crff1d4f ac more">
				<span  @click="more">{{moretext}}</span>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {
        return {
			detail:'',
			isMore:false,
			moretext:'+ Read more'
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
		this.moretext = '+ '+this.$t('Read_more')
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		more(){
			this.isMore = !this.isMore
			if(this.isMore){
				this.moretext = '- '+this.$t('Read_more')
			}else{
				this.moretext = '+ '+this.$t('Read_more')
			}
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'knowledge_id':this.$route.query.id}
			that.$api.post('/user/detail',data,r =>{
				that.$parent.returnCode(r,function(){
					that.detail = r.data
					that.$parent.loadModal(false);
                });

			})
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/contentDetail.vue